import { CultureSearchTransform } from '../models/configuration/CultureSearchTransform';

export default function cultureSearchTransformReplace(
    cultureSearchTransform: CultureSearchTransform,
    cultureCode: string
) {
    if (cultureSearchTransform) {
        for (const key of Object.keys(cultureSearchTransform)) {
            const collection = cultureSearchTransform[key];
            if (collection && collection.includes(cultureCode)) {
                return key;
            }
        }
    }
    return cultureCode;
}



// WEBPACK FOOTER //
// ./src/utils/cultureSearchTransformReplace.ts